const Jt = {};

Jt.event = {
	stopDefault(e) {
		if(e && e.preventDefaule) {
			e.preventDefaule();
		}
		else {
			window.event.returnValue = false;
		}
		return false;
	}
};

Jt.string = {
	unicode(str) {
		str = str ? (str + "") : "";
		var i, len = str.length, value = "";
		for(i = 0 ; i < len; i++) {
			value += "\\u" + parseInt(str.charCodeAt(i)).toString(16);
		}
		return value;
	},
	trim(str) {
		return String(str).replace(/^\s+|\s+$/g, "");
	},
	isEmpty(str) {
		return str === undefined || str === null || this.trim(str) === "";
	}
};

Jt.array = {
	isEmpty: function(arr) {
		return arr === undefined || arr === null || arr.length === 0;
	}
};

Jt.function = {
	throttle: function(fn, delay) {
		let now, lastExec, timer, context, args;
		let execute = function() {
			fn.apply(context, args);
			lastExec = now;
		}
		return function() {
			context = this;
			args = arguments;
			now = Date.now();
			if(timer) {
				clearTimeout(timer);
				timer = null;
			}
			if(lastExec) {
				var diff = delay - (now - lastExec);
				if(diff < 0) {
					execute();
				}
				else {
					timer = setTimeout(() => {
						execute();
					}, diff);
				}
			}
			else {
				execute();
			}
		}
	}
};

Jt.object = {
	isEmpty(obj) {
		let name;
		for(name in obj) {
			return false;
		}
		return true;
	}
};

Jt.browser = {
	stopBodyScroll() {
		$("body").on("touchmove mousewheel", Jt.event.stopDefault);
	},
	startBodyScroll() {
		$("body").off("touchmove mousewheel", Jt.event.stopDefault);
	}
};

Jt.dom = {
	getScrollTop(el) {
		let scrollTop = 0;
		if(el && el !== window) {
			scrollTop = el.scrollTop;
		}
		else {
			scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
		}
		return scrollTop;
	},
	getClientHeight(el) {
		if(el && el !== window) {
			return el.clientHeight;
		}
		return document.documentElement.clientHeight;
	}
}

module.exports = exports = Jt;


// WEBPACK FOOTER //
// ./src/lib/jt.js